var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconDrag = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 9 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M6.823 7.529a.53.53 0 1 0 0-1.06.53.53 0 0 0 0 1.06Z",
  fill: "#94A3B8",
  stroke: "#94A3B8",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "square"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.823 13a.53.53 0 1 0 0-1.059.53.53 0 0 0 0 1.06Z",
  fill: "#94A3B8",
  stroke: "#94A3B8",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "square"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M6.823 2.059a.53.53 0 1 0 0-1.059.53.53 0 0 0 0 1.059Z",
  fill: "#94A3B8",
  stroke: "#94A3B8",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "square"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M1.53 7.529a.53.53 0 1 0 0-1.06.53.53 0 0 0 0 1.06Z",
  fill: "#94A3B8",
  stroke: "#94A3B8",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "square"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M1.53 13a.53.53 0 1 0 0-1.059.53.53 0 0 0 0 1.06Z",
  fill: "#94A3B8",
  stroke: "#94A3B8",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "square"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M1.53 2.059A.53.53 0 1 0 1.53 1a.53.53 0 0 0 0 1.059Z",
  fill: "#94A3B8",
  stroke: "#94A3B8",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "square"
})));
export default SvgIconDrag;